import { useCartStore } from "@/entities/cart/lib/store";
import { useFavoritesStore } from "@/entities/favorite/lib/store";
import { initCartServerSync } from "@/entities/cart/lib/server-sync";

void useCartStore.getState().hydrate();
void useFavoritesStore.getState().hydrate();

initCartServerSync();
